import { MutationTree } from 'vuex';
import { IAuthState, IUserState } from '../types';
import { IUserProfile } from '@/shared/models/user';

export const mutations: MutationTree<IUserState> = {
  SET_PROFILE(state, payload: IUserProfile) {
    state.profile = payload;
  },
};
